module.exports = __webpack_public_path__ + "static/media/one-on-one-edit.d35b00b1.svg";